import { render, staticRenderFns } from "./SalesmanList.vue?vue&type=template&id=72e60fde"
import script from "./SalesmanList.vue?vue&type=script&lang=js"
export * from "./SalesmanList.vue?vue&type=script&lang=js"
import style0 from "./SalesmanList.vue?vue&type=style&index=0&id=72e60fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports